module.exports = __webpack_public_path__ + "img/timeline_amp.2b387ea3.svg";